module.exports = __webpack_public_path__ + "assets/img/2fcce73dcd817397f1e37440b9116d0a.svg";